// src/poker/components/SetupPanel.js
import React from "react";
import { clampInt } from "../pokerClock.logic";

function Field({ label, children }) {
  return (
    <div style={{ display: "grid", gap: 6 }}>
      <div style={{ fontSize: 12, opacity: 0.85 }}>{label}</div>
      {children}
    </div>
  );
}

function MiniField({ label, children }) {
  return (
    <div style={{ display: "grid", gap: 4 }}>
      <div style={{ fontSize: 11, opacity: 0.8 }}>{label}</div>
      <div style={{ width: 120 }}>{children}</div>
    </div>
  );
}

export default function SetupPanel({
  settings,
  setField,
  updatePayoutRow,
  addPayoutRow,
  removePayoutRow,
  prizePool,
  payoutErrors,
}) {
  return (
    <div className="panel-card">
      <div style={{ fontWeight: 800, marginBottom: 10 }}>Ustawienia turnieju</div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <Field label="Nazwa">
          <input className="input" value={settings.title} onChange={(e) => setField("title", e.target.value)} />
        </Field>

        <Field label="Gracze">
          <input
            className="input"
            type="number"
            value={settings.players}
            onChange={(e) => setField("players", clampInt(e.target.value, 2, 50, 8))}
          />
        </Field>

        <Field label="Start stack">
          <input
            className="input"
            type="number"
            value={settings.startingStack}
            onChange={(e) => setField("startingStack", clampInt(e.target.value, 1, 100000000, 20000))}
          />
        </Field>

        <Field label="Wpisowe">
          <input
            className="input"
            type="number"
            value={settings.buyin}
            onChange={(e) => setField("buyin", clampInt(e.target.value, 0, 1000000, 50))}
          />
        </Field>

        <Field label="Fee (opcjonalnie)">
          <input
            className="input"
            type="number"
            value={settings.fee}
            onChange={(e) => setField("fee", clampInt(e.target.value, 0, 1000000, 0))}
          />
        </Field>
      </div>

      <div style={{ height: 12 }} />

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
        <label style={{ display: "flex", gap: 8, alignItems: "center", cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={!!settings.rebuyEnabled}
            onChange={(e) => setField("rebuyEnabled", e.target.checked)}
          />
          Rebuy (dokupienie)
        </label>

        {settings.rebuyEnabled ? (
          <>
            <MiniField label="Cena">
              <input
                className="input"
                type="number"
                value={settings.rebuyPrice}
                onChange={(e) => setField("rebuyPrice", clampInt(e.target.value, 0, 1000000, 50))}
              />
            </MiniField>
            <MiniField label="Żetony">
              <input
                className="input"
                type="number"
                value={settings.rebuyChips}
                onChange={(e) => setField("rebuyChips", clampInt(e.target.value, 1, 100000000, 20000))}
              />
            </MiniField>
            <MiniField label="Do poziomu">
              <input
                className="input"
                type="number"
                value={settings.rebuyUntilLevel}
                onChange={(e) => setField("rebuyUntilLevel", clampInt(e.target.value, 1, 50, 6))}
              />
            </MiniField>
          </>
        ) : null}
      </div>

      <div style={{ height: 8 }} />

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
        <label style={{ display: "flex", gap: 8, alignItems: "center", cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={!!settings.reentryEnabled}
            onChange={(e) => setField("reentryEnabled", e.target.checked)}
          />
          Re-entry (ponowne wejście)
        </label>

        {settings.reentryEnabled ? (
          <MiniField label="Cena">
            <input
              className="input"
              type="number"
              value={settings.reentryPrice}
              onChange={(e) => setField("reentryPrice", clampInt(e.target.value, 0, 1000000, 50))}
            />
          </MiniField>
        ) : null}
      </div>

      <div style={{ height: 14 }} />

      <div style={{ fontWeight: 800, marginBottom: 8 }}>Payout (podział nagród)</div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
        <label style={{ display: "flex", gap: 8, alignItems: "center", cursor: "pointer" }}>
          <input type="radio" checked={settings.payoutMode === "percent"} onChange={() => setField("payoutMode", "percent")} />
          Procenty
        </label>
        <label style={{ display: "flex", gap: 8, alignItems: "center", cursor: "pointer" }}>
          <input type="radio" checked={settings.payoutMode === "amount"} onChange={() => setField("payoutMode", "amount")} />
          Kwoty
        </label>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        {(settings.payout || []).map((row, i) => (
          <div key={i} style={{ display: "grid", gridTemplateColumns: "80px 1fr 40px", gap: 8 }}>
            <input
              className="input"
              type="number"
              value={row.place}
              onChange={(e) => updatePayoutRow(i, { place: clampInt(e.target.value, 1, 50, row.place) })}
              title="Miejsce"
            />
            <input
              className="input"
              type="number"
              value={row.value}
              onChange={(e) => updatePayoutRow(i, { value: Number(e.target.value) })}
              title={settings.payoutMode === "percent" ? "Procent" : "Kwota"}
            />
            <button className="btn-secondary" type="button" onClick={() => removePayoutRow(i)} title="Usuń">
              ✕
            </button>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
        <button className="btn-secondary" type="button" onClick={addPayoutRow}>
          + Dodaj miejsce
        </button>
      </div>

      {/* (opcjonalnie) błąd payoutu także tutaj na dole */}
      {payoutErrors?.length ? (
        <div style={{ marginTop: 10, fontSize: 12, color: "var(--color-accent)", opacity: 0.95 }}>
          {payoutErrors.map((e, idx) => (
            <div key={idx}>⚠ {e}</div>
          ))}
          {typeof prizePool === "number" ? null : null}
        </div>
      ) : null}
    </div>
  );
}
